export const formatNumberWithPrecision = (cellValue?: string | null) => {
  if (cellValue === undefined || cellValue === null) {
    return '';
  }
  const numberValue = +cellValue;
  if (Number.isNaN(numberValue) || !Number.isFinite(numberValue)) {
    return '';
  }
  // Normalize -0 to 0
  const safeNumber = Object.is(numberValue, -0) ? 0 : numberValue;

  const decimalPlaces = cellValue.includes('.') ? cellValue.split('.')[1].length : 0;
  return safeNumber.toLocaleString('en-US', {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces
  });
};
